import { getEnvVar } from '@vimond/utils/env';
import { ResourcesConfig } from 'aws-amplify';
import { AppType } from '../../provider/provider.type';

const getIdentityPoolId = () => {
  const poolId = getEnvVar('NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID');
  return poolId ?? process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID ?? '';
};

const getUserPoolId = () => {
  const poolId = getEnvVar('NEXT_PUBLIC_COGNITO_USER_POOL_ID');
  if (!poolId) {
    console.warn(
      'Missing NEXT_PUBLIC_COGNITO_USER_POOL_ID environment variable',
    );
  }
  return poolId ?? process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID ?? '';
};

const getClientId = () => {
  const clientId = getEnvVar('NEXT_PUBLIC_COGNITO_CLIENT_ID');
  if (!clientId) {
    console.warn('Missing NEXT_PUBLIC_COGNITO_CLIENT_ID environment variable');
  }
  return clientId ?? process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID ?? '';
};

export const getWebConfig = () => ({
  Auth: {
    Cognito: {
      identityPoolId: getIdentityPoolId(),
      userPoolId: getUserPoolId(),
      userPoolClientId: getClientId(),
      loginWith: {
        oauth: {
          responseType: 'code' as const,
          domain: `${getEnvVar('NEXT_PUBLIC_ENVIRONMENT')}-${getEnvVar('NEXT_PUBLIC_ORGANIZATION_ID')}-${getEnvVar('NEXT_PUBLIC_TENANT_ID')}-end-users.auth.eu-north-1.amazoncognito.com`,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            `${getEnvVar('NEXT_PUBLIC_PRODUCTION_DOMAIN') ?? `https://${getEnvVar('NEXT_PUBLIC_TENANT')}.vimond-via-app-builder.${getEnvVar('NEXT_PUBLIC_ENVIRONMENT')}.vmnd.tv`}/vipps-redirect`,
            'http://localhost:3000/vipps-redirect',
          ],
          redirectSignOut: [
            `${getEnvVar('NEXT_PUBLIC_PRODUCTION_DOMAIN') ?? `https://${getEnvVar('NEXT_PUBLIC_TENANT')}.vimond-via-app-builder.${getEnvVar('NEXT_PUBLIC_ENVIRONMENT')}.vmnd.tv`}/vipps-redirect`,
            'http://localhost:3000',
          ],
        },
      },
    },
  },
});

export const getMobileConfig = (): ResourcesConfig => {
  const baseConfig = getWebConfig();
  const appScheme = getEnvVar('NEXT_PUBLIC_APP_SCHEME') ?? 'vimond';

  return {
    ...baseConfig,
    Auth: {
      ...baseConfig.Auth,
      Cognito: {
        ...baseConfig.Auth?.Cognito,
        loginWith: {
          ...baseConfig.Auth?.Cognito?.loginWith,
          oauth: {
            ...baseConfig.Auth?.Cognito?.loginWith?.oauth,
            responseType: baseConfig.Auth?.Cognito?.loginWith?.oauth
              ?.responseType as 'code' | 'token',
            redirectSignIn: [`${appScheme}://`],
            redirectSignOut: [`${appScheme}://`],
          },
        },
      },
    },
  };
};

export const selectConfig = ({
  appType,
}: {
  appType: AppType;
}): ResourcesConfig => {
  switch (appType) {
    case 'mobile':
      return getMobileConfig();
    default:
      return getWebConfig();
  }
};
